import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type AdvisorSeverity = "Suggestion" | "Warning" | "Critical";

export interface AdvisorCard {
  ruleKey: string;
  title: string;
  body: string;
  severity: AdvisorSeverity;
  daysUntilDeadline?: number | null;
  estimatedDollarImpact?: number | null;
  takeoverDashboard?: boolean;
  primaryActionLabel?: string | null;
  primaryActionRoute?: string | null;
  /** Optional second action shown next to the primary one (e.g. "Mark not currently required" on the BOI card). */
  secondaryActionLabel?: string | null;
  secondaryActionRoute?: string | null;
  authorityUrl?: string | null;
}

export function useAdvisorCards() {
  return useQuery({
    queryKey: ["advisor", "cards"],
    queryFn: async (): Promise<AdvisorCard[]> => {
      const r = await api().get<AdvisorCard[]>("/api/advisor/cards");
      return r.data;
    },
    staleTime: 30_000,
  });
}
